import React from 'react';
import { PageTitle } from '@cordata/buffet';

import DiagnosisForm from '~/components/Diagnosis/Form';

const DiagnosisAdd = () => (
  <>
    <PageTitle>Add Diagnosis</PageTitle>

    <DiagnosisForm isNew />
  </>
);

export default DiagnosisAdd;
